import { environment } from '../../environments/environment';

export function ensureStorageUrl(value?: string): string | undefined {
  if (!value) {
    return undefined;
  }

  if (value.startsWith('data:') || value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  const apiBaseUrl = environment.apiUrl.replace(/\/api\/?$/, '');

  if (value.startsWith('/')) {
    return apiBaseUrl + value;
  }

  return `${apiBaseUrl}/storage/${value}`;
}
